<template>
    <div class="is-full-width px-5 is-flex">
        <div class="is-flex is-flex-direction-row ">
            <p class="header_text classify_title mb-1 is-align-self-flex-start">
                {{ selectedTypeFile.label }}
            </p>
            <div class="ml-4 pill_month_header is-flex is-justify-content-center">
                <span class="text_pill is-capitalized">
                    {{ selectedDate.month }} {{ selectedDate.year }}
                </span>
            </div>
        </div>
        <div class="" style="margin-left: auto;">
            <button class="close_button" aria-label="Cerrar Modal" @click="$emit('close-modal');">
                <Ecs class="ecs" />
            </button>
        </div>
    </div>
</template>
<script>
import Ecs from "@/components/svg/Ecs.vue";
import { mapState } from "vuex";
export default {
    name: "HeaderUploadDocs",
    components: {
        Ecs,
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    computed: {
        ...mapState("uploadFiles", ["selectedDate", "selectedTypeFile"]),
    },
}
</script>
<style scoped lang="scss">
.ecs {
    width: 100%;
    position: relative;
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
}

.close_button {
    margin: 0 !important;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid #d0d5dd;
    box-sizing: border-box;
    width: 36px;
    height: 36px;
    overflow: hidden;
    padding-top: 5px;
}

.header_text {
    color: var(--Gray-900, #101828);
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 38px;
}

.pill_month_header {
    border-radius: 16px;
    border: 1px solid var(--Gray-200, #EAECF0);
    background-color: var(--Gray-50, #F9FAFB);
    padding: 4px 12px;
    align-items: center;


    .text_pill {
        color: var(--Gray-900, #101828);
        text-align: center;
        font-size: 18px;
        font-weight: 600;
        line-height: 28px;
    }
}
</style>